import { render, staticRenderFns } from "./AppCard_old.vue?vue&type=template&id=401919fe&scoped=true&"
import script from "./AppCard_old.vue?vue&type=script&lang=js&"
export * from "./AppCard_old.vue?vue&type=script&lang=js&"
import style0 from "./AppCard_old.vue?vue&type=style&index=0&id=401919fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401919fe",
  null
  
)

export default component.exports